import { INITIAL_KEY_SELECTION_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[INITIAL_KEY_SELECTION_MODULE_ID]: {
		moduleType: 'modal',
		modalTitle: 'Select Your Platform',
		modalText: 'This Drop is available on the platforms below. Click an icon to choose.',
		modalContent: {
			buttonText: 'GET KEY!',
		},
	},
}
